const gettingStartedLinks = [
  {
    "name": "Installation",
    "to": "/docs/installation",
  },
  {
    "name": "First App",
    "to": "/docs/",
  },
  {
    "name": "Next Steps",
    "to": "/docs/",
  },
];

export default gettingStartedLinks;
